import * as React from "react"
import {Box, Skeleton} from "@mui/material";
import {ButtonIconSeeker} from "@ui-seeker/core";

import { AdminProductReviewBaseTable } from "../@components"
import { useAdminProductReviewItems } from "../@hooks";
import { isLoadingCommonFilters } from "@signals";
import { adminProductReviewItemClicked } from "../@signals";


export default function AdminProductReviewItemsTable() {
	const { showTable, tableData } = useAdminProductReviewItems()

	if (!showTable) return <></>
	
	return <Box id="product-review-details-table">
		<AdminProductReviewBaseTable
			hideActions
			title="Product Review Results Details"
			subtitle="List of items behind."
			data={tableData}
			options={{
				customToolbar: () => <ButtonIconSeeker
					icon="times"
					onClick={() => adminProductReviewItemClicked.value = null}
					tooltip="Close Table"
				/>
			}}
		/>
	</Box>
}